import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDrywall } from '../features/drywall/drywallSlice'
import Spinner from '../components/Spinner'
import { sendPageView } from '../gtmUtils'

function Drywall() {
	const dispatch = useDispatch()

	const { drywall, isLoading, isSuccess } = useSelector((state) => state.drywall)

	useEffect(() => {
		sendPageView()
		dispatch(getDrywall())
	}, [dispatch])

	return (
		<>
			{isLoading || !isSuccess ? (
				<Spinner />
			) : (
				<div className='container'>
					<div className='drywall'>
						<h1 className='large'>Drywall Projects</h1>
						<p>Experienced in drywall installation, patching, mudding, and taping.</p>
						<p>
							We can handle anything from drywalling basements from scratch to small patches. We
							also do painting if required.
						</p>
						<br />

						<p className='large'>Previous Projects</p>
						<div className='projects-grid'>
							<div className='project'>
								<h3>Drywall replacement after backsplash removal</h3>
								<p>During Repairs</p>
								<div className='project-grid'>
									{drywall[0].during.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>

								<p>After</p>
								<div className='project-grid'>
									{drywall[0].after.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>
							</div>

							<div className='project'>
								<h3>Drywall installation finishing a basement.</h3>
								<p>After hanging, taping, mudding, and sanding.</p>
								<div className='project-grid'>
									{drywall[1].during.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>

								<p>After painting and trim installation</p>
								<div className='project-grid'>
									{drywall[1].after.map((image, index) => (
										<div className='project-item' key={index}>
											<a href={image.full} target='_blank' rel='noreferrer'>
												<img src={image.thumbnail} alt={image.name} />
											</a>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default Drywall
